module.exports = __webpack_public_path__ + "static/media/kinkhao_01_thumb_hover.53a5c9b8.png";